module.exports = __webpack_public_path__ + "static/media/lito_paper_pro.daa34016.jpg";